<template>
  <div class="columns is-multiline is-variable is-mobile is-5">
    <div class="column" :class="columnClasses" v-for="result in reviewResults" :key="result.id">
      <!-- shows files and multiple files in a table -->
      <review-documents-component
        v-if="result.isFileField()"
        class="document-table"
        :reviewResults="[result]"
        v-on:openCommentSection="$emit('openCommentSection', result)"
        v-on:stateOK="$emit('stateOK', result)"
        v-on:stateNotOK="$emit('stateNotOK', result)"
        v-on:statePENDING="$emit('statePENDING', result)">
      </review-documents-component>
      <!-- shows everything else as strings -->
      <review-cell-component
        v-else
        :label="result.getLabel()"
        :value="result.getValue()">
        <template v-slot:actions>
          <review-actions-component
            :result="result"
            v-on:openCommentSection="$emit('openCommentSection', result)"
            v-on:stateOK="$emit('stateOK', result)"
            v-on:stateNotOK="$emit('stateNotOK', result)"
            v-on:statePENDING="$emit('statePENDING', result)">
          </review-actions-component>
        </template>
        <!-- handles dependencies -->
        <template v-slot:dependencies>
          <review-dependency-component
            v-for="(dependency, key) in result.dependencies" :key="key"
            :dependency="dependency">
          </review-dependency-component>
        </template>
      </review-cell-component>
    </div>
  </div>
</template>
<script>
  import ReviewCellComponent from '@/components/layout/custom_grid/ReviewCellComponent.vue'
  import ReviewDependencyComponent from '@/components/layout/custom_grid/ReviewDependencyComponent.vue'
  import ReviewDocumentsComponent from '@/components/layout/case_review/ReviewDocumentsComponent'
  import ReviewActionsComponent from '@/components/layout/case_review/ReviewActionsComponent'

  export default {
    name: 'review-grid-component',
    components: {
      ReviewCellComponent,
      ReviewDependencyComponent,
      ReviewDocumentsComponent,
      ReviewActionsComponent
    },
    props: {
      reviewResults: {
        type: Array,
        required: true
      },
      columnClasses: {
        type: String,
        default: 'is-6-mobile is-4-tablet is-3-desktop'
      }
    }
  }
</script>
<style lang="sass" scoped>
  .document-table
    margin-bottom: 1rem
</style>
